import React, { useState } from 'react';
import { useVideoCallContext } from '../contexts/VideoCallContext';
import { VideoCallWindow, IncomingCallDialog, PreCallSettings } from './chat/VideoCallWindow';

/**
 * Global Video Call UI - renders incoming call dialogs and active call windows
 * This component should be placed high in the component tree (e.g., in App.js)
 * so video calls work from any page
 */
export const GlobalVideoCall = () => {
  const videoCall = useVideoCallContext();
  const [showPreCallSettings, setShowPreCallSettings] = useState(false);
  const [pendingCallSession, setPendingCallSession] = useState(null);
  
  // Handle incoming call accept - show device settings first
  const handleAcceptIncoming = () => {
    setPendingCallSession(videoCall.incomingCall?.session_id);
    setShowPreCallSettings(true);
  };
  
  // Handle starting call with selected devices
  const handleStartWithDevices = async (settings) => {
    setShowPreCallSettings(false);
    
    if (pendingCallSession && settings.stream) {
      // Joining an incoming call
      await videoCall.joinCallWithStream(pendingCallSession, settings.stream);
      setPendingCallSession(null);
    }
  };
  
  const handleCancelPreCall = () => {
    setShowPreCallSettings(false);
    setPendingCallSession(null);
    // Stop any preview stream
  };
  
  return (
    <>
      {/* Pre-Call Settings Dialog */}
      {showPreCallSettings && (
        <PreCallSettings
          onStart={handleStartWithDevices}
          onCancel={handleCancelPreCall}
          callType="video"
        />
      )}
      
      {/* Active Call Window */}
      {videoCall.activeCall && !showPreCallSettings && (
        <VideoCallWindow
          activeCall={videoCall.activeCall}
          participants={videoCall.participants}
          localStream={videoCall.localStream}
          remoteStreams={videoCall.remoteStreams}
          mediaState={videoCall.mediaState}
          onLeave={videoCall.leaveCall}
          onEnd={videoCall.endCall}
          onToggleAudio={videoCall.toggleAudio}
          onToggleVideo={videoCall.toggleVideo}
          onToggleScreenShare={videoCall.toggleScreenShare}
          isHost={videoCall.activeCall?.initiated_by === videoCall.currentUserId}
          currentUserId={videoCall.currentUserId}
        />
      )}
      
      {/* Incoming Call Dialog */}
      {videoCall.incomingCall && !videoCall.activeCall && !showPreCallSettings && (
        <IncomingCallDialog
          call={videoCall.incomingCall}
          onAccept={handleAcceptIncoming}
          onDecline={videoCall.declineCall}
        />
      )}
    </>
  );
};

export default GlobalVideoCall;
